// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { listLineContainerStyles } from "@synd/App/Components/MyListsDetails/ListLineContainer";
import { avoidBreakInsidePrintElement, color, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

listLineContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: minmax(13px, max-content) 118px minmax(0, 1fr) 284px;
        ${({ isCondensed }: any) => {
            if (isCondensed) {
                return css`
                    grid-template-columns: minmax(13px, max-content) minmax(0, 1fr) 296px;
                `;
            }
        }}
        width: 100%;
        background: ${color("common.white")};
        padding: 12px 0;
        grid-row-gap: 8px;
        ${xScreen("lte", "md")} {
            grid-template-columns: minmax(13px, max-content) 118px minmax(0, 1fr) 223px;
        }

        ${xScreen("lt", "sm")} {
            grid-template-columns: 96px 1fr 1fr;
            grid-row-gap: 12px;
        }
        ${avoidBreakInsidePrintElement}
        @media print {
            margin: 1px 0; // show borders on print
        }
    `,
};

listLineContainerStyles.checbox = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 2;
        line-height: 16px;
        padding-right: 24px;
        ${xScreen("lt", "sm")} {
            grid-column: 1 /4;
            grid-row: 1 / 2;
            padding-right: 0;
        }
    `,
};

listLineContainerStyles.image = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 2;
        position: relative;

        ${({ isCondensed }: any) => {
            if (isCondensed) {
                return css`
                    display: none;
                `;
            }
        }}

        ${xScreen("lt", "sm")} {
            grid-column: 1 /2;
            grid-row: 2 / 3;
        }
    `,
};

listLineContainerStyles.description = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 2;
        display: inline-flex;
        flex-direction: column;
        padding: 0 23px 0 8px;
        ${({ isCondensed }: any) => {
            if (isCondensed) {
                return css`
                    grid-column: 2 / 3;
                `;
            }
        }}

        ${xScreen("lt", "sm")} {
            grid-column: 2 / 4;
            grid-row: 2 / 3;
            padding: 0 0 0 8px;
        }
    `,
};

listLineContainerStyles.price = {
    css: css`
        grid-column: 4 / 5;
        grid-row: 1 / 2;
        ${({ isCondensed }: any) => {
            if (isCondensed) {
                return css`
                    grid-column: 3 / 4;
                `;
            }
        }}

        ${xScreen("lt", "sm")} {
            grid-column: 1 / 4;
            grid-row: 3 / 4;
            & div[data-test-selector="priceIncludeVat"] {
                padding-left: 104px;
            }
        }

        @media print {
            grid-column: 1 / 4;
            grid-row: 3 / 3;
        }
    `,
};

listLineContainerStyles.deleteItem = {
    css: css`
        grid-column: 4 / 5;
        grid-row: 2 / 3;
        display: flex;
        justify-content: flex-end;
        ${({ isCondensed }: any) => {
            if (isCondensed) {
                return css`
                    grid-row: 1 / 2;
                    align-items: flex-start;
                    padding-left: 24px;
                `;
            }
        }}

        ${xScreen("lt", "sm")} {
            grid-column: 3 / 4;
            grid-row: 4 / 5;
        }
        @media print {
            grid-column: 1 / 6;
            grid-row: 7 / 8;
        }
    `,
};

listLineContainerStyles.notes = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 2 / 3;
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 0 23px 0 8px;

        ${({ isCondensed }: any) => {
            if (isCondensed) {
                return css`
                    grid-column: 2 / 3;
                `;
            }
        }}

        ${xScreen("lt", "sm")} {
            grid-column: 1 / 3;
            grid-row: 4 / 5;
        }
        @media print {
            grid-column: 1 / 6;
            grid-row: 6 / 7;
        }
    `,
};

listLineContainerStyles.notesField = {
    css: css`
        &:empty {
            display: none;
        }
        grid-column: 1 / 4;
        grid-row: 5 / 6;
        display: flex;
        @media print {
            display: none;
        }
    `,
};
